var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSiemens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 16,
    viewBox: "0 0 96 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2625 0.871526V3.74159C92.791 3.18027 91.4808 2.89646 90.3341 2.89646C89.6549 2.89646 89.114 3.02355 88.7074 3.26925C88.3007 3.51707 88.0931 3.8221 88.0931 4.18218C88.0931 4.66088 88.5522 5.08659 89.4767 5.4679L92.1474 6.78114C94.3066 7.82116 95.3778 9.20215 95.3778 10.9369C95.3778 12.3794 94.8097 13.5295 93.663 14.381C92.5247 15.241 90.9923 15.6667 89.0847 15.6667C88.2042 15.6667 87.4139 15.6286 86.7117 15.5481C86.0094 15.4719 85.2023 15.3151 84.3072 15.0906V12.0871C85.9486 12.6484 87.4433 12.9322 88.7891 12.9322C90.3949 12.9322 91.1936 12.462 91.1936 11.5131C91.1936 11.0407 90.8665 10.6595 90.202 10.3608L87.2357 9.08354C86.1415 8.58367 85.3281 7.97788 84.7956 7.25984C84.2716 6.53544 84.0053 5.70513 84.0053 4.7562C84.0053 3.42809 84.5587 2.35843 85.653 1.54506C86.7557 0.73804 88.2189 0.333496 90.0385 0.333496C90.6297 0.333496 91.311 0.386428 92.0657 0.483871C92.8266 0.587666 93.5582 0.71475 94.2625 0.871526V0.871526Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2509 0.871526V3.74159C8.77932 3.18027 7.47124 2.89646 6.32455 2.89646C5.64324 2.89646 5.10452 3.02355 4.69781 3.26925C4.29115 3.51707 4.08361 3.8221 4.08361 4.18218C4.08361 4.66088 4.54899 5.08659 5.47346 5.4679L8.14416 6.78114C10.295 7.82116 11.3683 9.20215 11.3683 10.9369C11.3683 12.3794 10.7981 13.5295 9.65979 14.381C8.5131 15.241 6.98909 15.6667 5.07518 15.6667C4.19471 15.6667 3.4023 15.6286 2.70004 15.5481C1.99777 15.4719 1.19907 15.3151 0.297697 15.0906V12.0871C1.94539 12.6484 3.44007 12.9322 4.77749 12.9322C6.38327 12.9322 7.18197 12.462 7.18197 11.5131C7.18197 11.0407 6.85703 10.6595 6.19877 10.3608L3.23252 9.08354C2.12984 8.58367 1.31647 7.97788 0.792414 7.25984C0.259931 6.53544 0 5.70513 0 4.7562C0 3.42809 0.549247 2.35843 1.64979 1.54506C2.74409 0.73804 4.20938 0.333496 6.029 0.333496C6.62644 0.333496 7.29936 0.386428 8.06239 0.483871C8.81709 0.587666 9.54869 0.71475 10.2509 0.871526Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3115 0.602539H17.6614V15.3978H13.3115V0.602539Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6752 0.602539V3.3371H25.2123V6.61807H30.8179V9.08359H25.2123V12.5277H31.8073V15.3978H21.026V0.602539H31.6752Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9821 0.602539V15.3978H47.9214V5.6395L43.708 15.5333H41.2009L37.1487 5.6395V15.3978H34.2118V0.602539H39.5217L43.1462 9.65973L46.9385 0.602539H51.9821Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9898 0.602539V3.3371H59.5622V6.61807H65.1677V9.08359H59.5622V12.5277H66.1219V15.3978H55.3406V0.602539H65.9898Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2528 0.602539V15.3978H76.639L71.4613 5.90849V15.3978H68.5262V0.602539H73.2746L78.3182 9.92877V0.602539H81.2528Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSiemens);
export default __webpack_public_path__ + "static/media/customer-siemens.ef4721abb3a3f8112303f61a19d769c7.svg";
export { ForwardRef as ReactComponent };